export const formatDateToISO = (dateString: string) => {
  const parts = dateString.toLowerCase().split("-");

  let day: string | null = null;
  let month = "";
  let year: string | null = null;

  if (parts.length === 3) {
    day = parts[0];
    month = parts[1];
    year = parts[2];
  } else if (parts.length === 2) {
    if (((/^\d+$/)).test(parts[0])) {
      day = parts[0];
      month = parts[1];
    } else {
      month = parts[0];
      year = parts[1];
    }
  } else {
    return "";
  }

  month = month.charAt(0).toUpperCase() + month.slice(1);

  // Build date string for parsing
  const dateStr = day ? `${month} ${day}${year ? ", " + year : ""}` : `${month} 01, ${year}`;
  const date = new Date(dateStr);

  const yyyy = date.getFullYear().toString();
  const mm = (date.getMonth() + 1).toString().padStart(2, "0");
  const dd = date.getDate().toString().padStart(2, "0");

  if (day && year) {
    return `${yyyy}-${mm}-${dd}`;
  }

  if (day && !year) {
    return `${mm}-${dd}`;
  }

  if (!day && year) {
    return `${yyyy}-${mm}`;
  }

  return "";
};
